import React, {useEffect, useState} from 'react';
import {
    Route,
    Redirect,
    RouteComponentProps
} from "react-router-dom";
import { authenticationService } from '../services/authenticationService';
//import axios from 'axios';
const queryString = require('query-string');

interface Props {
    Component: React.FC<RouteComponentProps>;
    path: string;
    exact?: boolean;
};

export default function AuthRoute(props: any) {
    const [isLoading, setIsLoading] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    //const isLoggedIn = true;

    useEffect(() => {

        const parsed = queryString.parse(props.location.search);
        if( parsed && parsed.key ) {
            authenticationService.login(parsed.key.toString()).then(data => {
                if( data ) {
                    setIsLoggedIn(true);
                    setIsLoading(false);
                } else {
                    setIsLoggedIn(false);
                    setIsLoading(false);
                    authenticationService.logout();
                }
                console.log('data',data);
            });
        } else {
            if( authenticationService.token ) {
                setIsLoggedIn(true);
                setIsLoading(false);
            }
        }

        /*if( isLoggedIn ) {

        } else {
            //const query = queryString.parse(props.location.search);
            axios({
                method: 'post',
                url: '/api/auth/isLoggedIn'
            }).then((res) => {
                console.log('login success',res.data);
                if( res.data.status ) {
                    setIsLoggedIn(true);
                    setIsLoading(false);
                } else {
                    setIsLoggedIn(false);
                    setIsLoading(false);
                }
            }, (err) => {
                setIsLoggedIn(false);
                setIsLoading(false);
            }).catch(err => {
                setIsLoggedIn(false);
                setIsLoading(false);
            });
        }*/
    }, [props.location.search]);
    if( isLoading )
        return null;
    else
        return isLoggedIn ? <Route path={props.path} component={props.component} exact={props.exact}/> :
                        <Redirect to={{ pathname: '/install', state: { from: props.location } }} />;
}
